export default __webpack_public_path__ + "static/media/roughTexture.d2e8bd4f.png";